import AsideTitle from './AsideTitle';

export default AsideTitle;
